import React from "react";

/**
 * 下一档展示。等级列表以 vip-levels 返回为准，不再截断到 VIP4。
 * 进度接口标记已是最高档时，下一档等于当前档。
 */
export function resolveEnabledNextInviteVipLevel(currentLevel, nextLevel, isMaxLevel) {
  const currentRaw = Number(currentLevel);
  const current = Number.isFinite(currentRaw) && currentRaw >= 1 ? Math.floor(currentRaw) : 1;
  if (isMaxLevel) return current;

  const nextRaw = Number(nextLevel);
  if (Number.isFinite(nextRaw) && nextRaw > current) return Math.floor(nextRaw);
  return current + 1;
}

/**
 * 等级规则卡右侧升级条件。人数用该档 directValidUserCount。
 * VIP1 默认等级；VIP2 不限下级档位；VIP3 起下级需达到上一档。
 */
export function formatVipLevelRequirement(vipLevel, directValidCount, t) {
  const level = Number(vipLevel);
  const count = Number(directValidCount);
  const countText = Number.isFinite(count) && count >= 0 ? String(Math.floor(count)) : "0";

  if (!Number.isFinite(level) || level <= 1) {
    return {
      isDefault: true,
      countText: "",
      childLevel: null,
      defaultText: t("home.affiliateVipReqDefault"),
    };
  }

  const childLevel = level >= 3 ? level - 1 : null;
  return { isDefault: false, countText, childLevel, defaultText: "" };
}

export function VipRequirementValue({ requirement, t, countClassName }) {
  if (!requirement || requirement.isDefault) {
    return requirement?.defaultText || "";
  }
  return (
    <>
      <span className={countClassName}>{requirement.countText}</span>
      <span> • </span>
      <span>{vipRequirementLabel(requirement, t)}</span>
    </>
  );
}

/** 当前等级进度：有下级 VIP 限制时写明档位，否则只写还差人数。 */
export function formatDirectValidRemainText(count, requirement, t) {
  const childLevel = requirement?.childLevel;
  if (childLevel) {
    return t("home.affiliateLevelDirectValidRemainVip", { count, childLevel });
  }
  return t("home.affiliateLevelDirectValidRemain", { count });
}

export function vipRequirementLabel(requirement, t) {
  if (!requirement || requirement.isDefault) return "";
  if (requirement.childLevel) {
    return t("home.affiliateVipReqChildUsers", { childLevel: requirement.childLevel });
  }
  return t("home.affiliateVipReqValidUsers");
}
